import { Smartphone, ExternalLink, Star } from "lucide-react";
import { Reveal } from "@/lib/motion";

const STEPS = [
  {
    n: "01",
    tag: "Tap",
    icon: Smartphone,
    text: "Customer holds their phone near the NFC stand.",
  },
  {
    n: "02",
    tag: "Open",
    icon: ExternalLink,
    text: "The business's Google review page opens.",
  },
  {
    n: "03",
    tag: "Review",
    icon: Star,
    text: "Customer can leave their genuine feedback.",
  },
];

export const Demo = () => (
  <section
    id="demo"
    className="bg-sand py-24 md:py-32"
    data-testid="demo-section"
  >
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <Reveal>
        <p className="text-overline">The experience</p>
        <h2 className="mt-4 max-w-2xl font-display text-4xl font-medium tracking-tight text-ink sm:text-5xl">
          One tap. That's it.
        </h2>
      </Reveal>

      {/* numbered manifesto chapters */}
      <div className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-3xl border border-black/5 bg-line md:grid-cols-3">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.12}>
            <div className="flex h-full flex-col justify-between bg-white p-8 md:p-10">
              <div className="flex items-start justify-between">
                <span className="font-display text-5xl font-medium tracking-tighter text-ink/15">
                  {s.n}
                </span>
                <s.icon className="h-6 w-6 text-ink" strokeWidth={1.5} />
              </div>
              <div className="mt-16">
                <p className="text-overline">{s.tag}</p>
                <p className="mt-3 text-lg leading-relaxed text-graphite">{s.text}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      {/* product demonstration video */}
      <Reveal delay={0.1}>
        <div
          className="relative mt-8 flex aspect-video w-full items-center justify-center overflow-hidden rounded-3xl bg-ink"
          data-testid="demo-video-placeholder"
        >
          <video
            src="/products/demo.mp4"
            className="h-full w-full object-contain"
            autoPlay
            muted
            loop
            playsInline
            controls
            preload="metadata"
            aria-label="Tap Review NFC stand in action: phone tap opens the Google review page"
            data-testid="demo-video"
          />
        </div>
      </Reveal>
    </div>
  </section>
);
